<form [formGroup]="uploadForm">
  <fieldset class="usa-fieldset">
    @for (progressInfo of progressInfos; track progressInfo) {
      <div>
        @if (showProgressBar) {
          <div>
            <span>{{ progressInfo.fileName }}</span>
            <div class="grid-row grid-gap">
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                <div
                  class="progress-bar progress-bar-info progress-bar-striped"
                  role="progressbar"
                  attr.aria-valuenow="{{ progressInfo.value }}"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  [ngStyle]="{ width: progressInfo.value + '%' }"
                  >
                  {{ progressInfo.value }}%
                </div>
              </div>
              <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
                {{ progressInfo.fileSize }}
                <!-- make the button round-->
                <button class="usa-button usa-button--secondary" title="click here to remove the file" (click)="removeAttachedFiles(progressInfo)">X</button>
              </div>
            </div>
          </div>
        }
      </div>
    }
    @for (file of files; track file) {
      <div class="mb-2" >
        @if (showSelectedFiles) {
          <div >
            <span>{{ file.name }}</span>
            <!-- <button type="button" class="usa-button usa-button--secondary" title="click here to remove the file" (click)="removeSelectedFiles(file)">X</button> -->
          </div>
        }
      </div>
    }
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <!--<label class="btn btn-default">-->
        <input type="file" formControlName="filePicker" name="filePicker" id="filePicker" multiple
          (change)="selectFiles($event)"/>
      <!--</label>-->
    </div>
  </div>
  <div class="grid-row grid-gap margin-y-2">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <button class="usa-button" [disabled]="!selectedFiles"
        (click)="uploadFiles()">Attach Selected Files
      </button>
    </div>
  </div>
  @if (message) {
    <div class="grid-row grid-gap">
      <div class="usa-alert usa-alert--error usa-alert--slim">
        <div class="usa-alert__body">
          <p class="usa-alert__text">
            {{message}}
          </p>
        </div>
      </div>
    </div>
  }
</fieldset>
</form>
